import React from 'react';
import cx from 'classnames';
import { string } from 'prop-types';
import segmentStatus from 'propTypes/segmentStatus';
import RouteIcon from 'icons/route.inline.svg';
import RouteBrokenIcon from 'icons/segment-small-broken.inline.svg';

import styles from './RouteNameDisplay.scss';

export default function RouteNameDisplay({
  routeName,
  fromLocationName,
  toLocationName,
  status,
  className,
}) {
  const isReporting = status !== 'disconnected';

  return (
    <div className={cx(styles.main, className)}>
      {isReporting
        ? <RouteIcon className={styles.routeIcon} />
        : <RouteBrokenIcon className={styles.routeIcon} />}
      <div className={styles.routeName}>
        <div>
          {routeName || fromLocationName}
        </div>
        <div>
          {routeName ? '' : toLocationName}
        </div>
      </div>
    </div>
  );
}

RouteNameDisplay.propTypes = {
  routeName: string,
  fromLocationName: string,
  toLocationName: string,
  status: segmentStatus.isRequired,
  className: string,
};



// WEBPACK FOOTER //
// ./src/components/RouteNameDisplay/index.js